export class PostTranslation {
    language: string = '';
    title: string = '';
    subtitle: string = '';
    author: string = '';
    post_summary: string = '';
    post_details: string = '';
}

export class ResponseTranslation {
    language: string = '';
    title: string = '';
    question: string = '';
    description: string = '';
    responseTexts: any[] = [];
    author: string = '';
 }

 export class AlertTranslation {
    language: string = '';
    title: string = '';
    description: string = '';
    author: string = '';
 }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/translation.service.ts